import { displayDate, displayMenu } from "~/plugins/functions/display";

export interface IModelUserInfo {
  id: number;
  username: string;
  email: string;
  userTeamRelations: any[];
}

export interface IModelHistoryLogResponse {
  id: string;
  action: string;
  eventName: string;
  entityType: string;
  entityId: string;
  userId: number;
  createdAt: string | Date;
  user: IModelUserInfo;
}

export class ModelHistoryLog {
  id: string;
  action: string;
  eventName: string;
  entityType: string;
  entityId: string;
  userId: number;
  createdAt: string | Date;
  user: IModelUserInfo;
  displayCreatedAt: string
  displayMenu: string;
  displayTeam: string;
  displayUsername: string;
  displayTime: string;

  constructor(props = {} as IModelHistoryLogResponse) {
    props = props ?? {};
    this.id = props.id || '';
    this.action = props.action || '';
    this.eventName = props.eventName || '';
    this.entityType = props.entityType || '';
    this.entityId = props.entityId || '';
    this.userId = props.userId || 0;
    this.createdAt = props.createdAt;
    this.user = props.user || {} as IModelUserInfo;
    this.displayCreatedAt = displayDate(this.createdAt);

    this.displayMenu =  displayMenu(this.entityType || '-') ;
    this.displayTeam = this.user?.userTeamRelations?.[0]?.team || 'System';
    this.displayUsername = this.user?.username || '-';
    this.displayTime = displayDate(this.createdAt, {isOnlyTime: true});
  }
}


